export type PreviousURLContextType = {
    previousURL: string;
    setPreviousURL: (previousURL: string) => void;
};

export const PreviousURLContextDefaultValues: PreviousURLContextType = {
    previousURL: '',
    // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
    setPreviousURL: () => {},
};
